import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap } from '@angular/router';
import {Gallery} from 'angular-gallery';
import { MLSListingService } from 'src/services/mls-listings.service';
import { Router } from '@angular/router';
//import * as mapboxgl from 'mapbox-gl';
import { environment } from '../../../environments/environment';
//import { env } from 'process';

//import { CarouselComponent } from 'angular-gallery';

// import { Lightbox } from "ngx-lightbox";

@Component({
    selector: "app-individual-listing",
    templateUrl: "./individual-listing.component.html",
    styleUrls: ["./individual-listing.component.css"],
})
export class IndividualListingComponent implements OnInit{
 
  
  // 

  //map: mapboxgl.Map;
  //style = 'mapbox://styles/mapbox/streets-v11';


  constructor(public gallery: Gallery, public route: ActivatedRoute, private mlsService: MLSListingService, private router: Router) {
    //(mapboxgl as any).accessToken = environment.mapbox.accessToken;
  }

  listing_id: string;
  listing_details: any;
  images_array = [];
  property_attributes : {name:string, value:string}[];

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      if (params.has("listing_id")) {
        this.listing_id = params.get("listing_id");
      }
    });

    this.mlsService.getListingDetails(this.listing_id).subscribe(res => {
      // console.log(res);
      this.listing_details = res as any;
      
    for(var i = 0; i< this.listing_details[0].photos.length; i++) {
      var value = {
        path: this.listing_details[0].photos[i]
      }
      this.images_array.push(value);

      
      
      
    }
    //this.getPropertyAttributes()
    })

    // console.log(this.images_array);
    // var map = new mapboxgl.Map({
    //   container: 'map-property',
    //   style: 'mapbox://styles/mapbox/streets-v11',
    //   center: this.getLatLng(),
    //   zoom: 16
    // });
    

  }

  showGallery(index: number) {

      let prop = {
        images: this.images_array,
        index
      };
      this.gallery.load(prop);
      
  }


 

  closeGallery() {
      this.gallery.close();
  }

  getPrice(x) {
    var price = parseInt(x);
    var final_price = '$' + this.numberWithCommas(price);
    return final_price;
  }

  numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  getPropertyAttributes() {
    var attribute = {
      name: "MLS#",
      value: this.listing_details[0].mlsId
    }
    this.property_attributes.push(attribute)
    // console.log(this.property_attributes)
    
  }

  contactAgent() {
    this.router.navigateByUrl("/contact");
  }
  


}


